module.exports = __webpack_public_path__ + "img/sweden-ill-defined-causes-male.9eb52d3d.png";